module.exports = __webpack_public_path__ + "img/cu02.8986fea8.jpg";